import { AuthoringAssistantDraftTarget } from '../../services/authoringAssistantService';

export interface AuthoringAssistantCreateNavigationState {
  authoringAssistantTarget?: AuthoringAssistantDraftTarget;
  authoringAssistantPrompt?: string;
  authoringAssistantAutoGenerate?: boolean;
}

export const buildAuthoringAssistantCreateState = (
  target: AuthoringAssistantDraftTarget,
  prompt?: string,
): AuthoringAssistantCreateNavigationState => {
  const trimmedPrompt = prompt?.trim();

  return {
    authoringAssistantTarget: target,
    authoringAssistantPrompt: trimmedPrompt || undefined,
    authoringAssistantAutoGenerate: true,
  };
};

export const getAuthoringAssistantCreateState = (
  state: unknown,
  target: AuthoringAssistantDraftTarget,
): { prompt?: string; autoGenerate: boolean } => {
  if (!state || typeof state !== 'object') {
    return { prompt: undefined, autoGenerate: false };
  }

  const navigationState = state as AuthoringAssistantCreateNavigationState;

  if (navigationState.authoringAssistantTarget !== target) {
    return { prompt: undefined, autoGenerate: false };
  }

  return {
    prompt: navigationState.authoringAssistantPrompt?.trim() || undefined,
    autoGenerate: Boolean(navigationState.authoringAssistantAutoGenerate),
  };
};